import React, { useState, useEffect } from "react";
import * as Icons from "../../assets/SVGs/index";
import { ImageUploadProps } from "../../types/public";

const ImageUpload: React.FC<ImageUploadProps> = ({
  onImageChange,
  onBlur,
  name,
  label,
  uploadButtonText = "آپلود تصویر",
  storageKey,
  maxFileSize = 2 * 1024 * 1024,
  defaultImage,
  helperText,
}) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (defaultImage) {
      setSelectedImage(defaultImage);
    } else {
      setSelectedImage(null);
    }
  }, [defaultImage]);

  const triggerBlur = () => {
    if (onBlur) {
      onBlur({ target: { name } } as React.FocusEvent<HTMLInputElement>);
    }
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > maxFileSize) {
        setError("حجم فایل از حداکثر محدودیت ۲ مگابایت بیشتر است.");
        return;
      }
      setError(null);

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        setSelectedImage(base64String);
        localStorage.setItem(storageKey, base64String);
        onImageChange(file);
        triggerBlur();
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDeleteImage = () => {
    setSelectedImage(null);
    onImageChange(null);
    localStorage.removeItem(storageKey);
    triggerBlur();
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <div className="w-full">
      {label && (
        <label htmlFor="image" className="block mb-2 text-lg font-medium">
          {label}
        </label>
      )}
      <div className="flex items-center">
        <div
          className={"bg-[#08645c] rounded px-[10px] py-[8px]"}

        >
          <input
            type="file"
            id="image"
            name={name}
            onChange={handleImageChange}
            className="hidden"
            accept=".png, .jpg, .jpeg, .svg"
            onBlur={handleBlur}
          />
          <label
            htmlFor="image"
            className="cursor-pointer flex items-center justify-center"
          >
            <Icons.UploadIcon className="w-6 h-6 text-white ml-3" />
            <span className="ml-2 text-sm text-white">
              {uploadButtonText}
            </span>
          </label>
        </div>
        {selectedImage && (
          <div className="relative">
            <img
              src={selectedImage}
              alt="Uploaded"
              className="w-[80px] h-[80px] object-cover border border-[#b2b2b2] rounded m-1"
            />
            <button
              onClick={handleDeleteImage}
              className="bg-[#FAFAFA] absolute left-1 top-1 rounded p-1"
            >
              <Icons.DeleteIcon className="w-4 h-4" />
            </button>
          </div>
        )}
      </div>
      {error && <p className="text-red-500 mt-2">{error}</p>}{" "}
      <div>
        {helperText && (
          <p className="text-right w-full text-[9px] text-mobasher-red mt-1 bottom-0 pl-1">
            * {helperText}
          </p>
        )}
      </div>
    </div>
  );
};

export default ImageUpload;
